import styled from '@emotion/styled'

export const ChooseFileText = styled.span`
font-size: 15px;
font-weight: 600;
line-height: 1.2;
text-align: center;
color: #f78b45;
text-decoration: underline;
`

export const FlexDisplay = styled.div`
display:flex;
justify-content: center;
margin-top: 35px;
margin-bottom:36px;
`